import React from 'react';
import { BaseAlert } from './baseAlert';
import { alertClasses, alertTypes } from '../constants';

export const noContentAlert = props => (
  <BaseAlert
    {...props}
    className={alertClasses[alertTypes.NO_CONTENT]}
  />
);

export default noContentAlert;
